!<!--  -->
<template>
  <div class="">
    <WrapCard title="产品报价设置">
      <div style="margin-bottom: 20px">
        <!-- 查询  -->
        <ErpSearchForm @getList="getList" @openAddDialog="openAddDialog" :requestParams="requestParams" :searchFromParams="searchFromParams"></ErpSearchForm>
      </div>
      <!-- 表格 -->

      <div>
        <Erp-table :tabelParams="tabelParams" :requestParams="requestParams">
          <!-- 状态 -->
          <template v-slot="row">
            <el-button size="mini" type="primary" @click="showDetailHandler(row)">查看</el-button>
            <el-button size="mini" type="warning" v-if="row.row.state == 1 || row.row.state == 4" @click="getListById(row)">修改</el-button>
            <el-button size="mini" type="danger" v-if="row.row.state != 2" @click="submitPrice(row.row.id)">提交</el-button>
          </template>
        </Erp-table>
      </div>

      <!-- 新增弹窗部分开始 -->
      <div>
        <AddDialog title="产品报价设置" ref="AddDialog" @clearAll="clearAll()" @submit="submit()" :showDialog="showDialog" class="2">
          <template v-slot :default="s">
            <div class="" style="position: relative">
              <!-- mask  -->
              <div v-if="addObject.state != 1" @click="warn()" style="
                  position: absolute;
                  z-index: 5;
                  width: 100%;
                  background-color: #8080802e;
                  height: 100%;
                "></div>
              <div style="display: flex">
                <div>
                  <h2>基本信息</h2>
                  <ErpForm @openAddDialog="openAddDialog" :fromParams="fromParams" :addObject="addObject"></ErpForm>
                </div>

                <div>
                  <h2>计费模板</h2>
                  <ErpForm @openAddDialog="openAddDialog" :fromParams="fromParams2" :addObject="addObject"></ErpForm>
                </div>
                <div style="margin-top: 0px">
                  <h2 style="margin: 15px 0 15px 0">区间</h2>
                  <transition-group name="el-fade-in-linear">
                    <div style="margin: 3px 0" v-for="(item, index) in addObject.templateData.detailList" :key="item.id">
                      <el-tag>
                        区间{{ index + 1 }}:
                        {{
                          ` 大于 
                        ${item.sectionEndNum}
                         ${addObject.templateData.chargeType}  —
                        小于等于 
                        ${item.sectionEndNum} 
                         ${addObject.templateData.chargeType}
                      `
                        }}
                      </el-tag>
                    </div>
                  </transition-group>
                </div>
              </div>
              <div style="text-align: right">
                <el-button v-if="addObject.state == 1" size="mini" type="success" @click="add()">新增</el-button>
              </div>
              <div>
                <el-table align="center" :header-cell-style="{
                    background: '#eef1f6',
                    color: '#606266',
                  }" size="mini" highlight-current-row :data="addObject.dataTable.tableBody" style="width: 100%; margin-top: 10px" border>
                  <el-table-column v-for="(item, index) in addObject.dataTable.tableHead" :key="index" align="center" :label="item.value">
                    <template slot-scope="scope">
                      <!-- 起运地  -->
                      <div v-if="item['attrName'] == 'start'" style="
                          display: flex;
                          justify-content: space-between;
                          margin: 5px;
                        ">
                        <div style="
                            width: 80%;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            margin: 0 10px;
                            text-align: center;
                          ">
                          <el-popover trigger="hover" placement="top">
                            {{
                              scope.row[item.attrName].value ||
                              "点击右侧按钮选择"
                            }}
                            <div slot="reference" class="name-wrapper">
                              {{
                                scope.row[item.attrName].value ||
                                "点击右侧按钮选择"
                              }}
                            </div>
                          </el-popover>
                        </div>
                        <el-button size="mini" type="primary" @click="selectDes('pol', scope.$index)">
                          选择起运地
                        </el-button>
                      </div>

                      <!-- 目的地  -->
                      <div v-if="item['attrName'] == 'end'" style="
                          display: flex;
                          justify-content: space-between;
                          margin: 5px;
                        ">
                        <div style="
                            margin: 0 10px;
                            text-align: center;
                            width: 80%;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                          ">
                          <el-popover trigger="hover" placement="top">
                            {{
                              scope.row[item.attrName].value ||
                              "点击右侧按钮选择"
                            }}
                            <div slot="reference" class="name-wrapper">
                              {{
                                scope.row[item.attrName].value ||
                                "点击右侧按钮选择"
                              }}
                            </div>
                          </el-popover>
                        </div>
                        <el-button size="mini" type="primary" @click="selectDes('pod', scope.$index)">
                          选择目的地
                        </el-button>
                      </div>
                      <el-input @input="
                          valieDataForInput(
                            $event,
                            scope.row[item.attrName],
                            'value'
                          )
                        " v-else-if="
                          item['attrName'] != 'end' &&
                          item['attrName'] != 'start'
                        " v-model="scope.row[item.attrName].value" size="mini">
                      </el-input>
                      <!-- {{ scope.row }} {{ item.attrName }} -->
                    </template>
                  </el-table-column>
                  <el-table-column width="80" label="操作" v-if="addObject.state == 1">
                    <template slot-scope="scope">
                      <el-button size="mini" type="danger" @click="deleteItem(scope.$index)">
                        删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </template>

          <template #button>
            <div style="text-align: center; margin-top: 20px">
              <el-button v-if="addObject.state == 1" size="mini" type="primary" @click="submit()">保 存</el-button>
              <el-button size="mini" type="danger" @click="clearAll()">
                {{ addObject && addObject.state == 1 ? "取 消" : "返 回" }}
              </el-button>
            </div>
          </template>
        </AddDialog>
      </div>

      <!-- 选起运地目的地弹窗部分开始 -->
      <AddDialogPlus :showDialog="showRange" :showClose="false">
        <template #main>
          <Erp-table :tabelParams="tabelParamsForRange" :requestParams="requestParamsForRange"></Erp-table>
        </template>
        <template #button>
          <el-button size="mini" type="primary" @click="showRange = false">返 回</el-button>
        </template>
      </AddDialogPlus>
      <!-- 查看 -->
      <AddDialogPlus :showDialog="showDetail" :showClose="false" width="40%">
        <template #main>
          <p style="font-weight:700;font-size:17px">基本信息</p>

          <div style="display: flex; flex-wrap: wrap">
            <div v-for="(item, index) in showObjectDetail" :key="index" style="width: 220px; margin: 10px 0" :style="{ width: item.prop == 'remark' ? '100%' : '220px' }">
              <div style="display: inline-block; color: #999999; width: 80px">
                <div>{{ item.name }}</div>
              </div>
              <span>{{ showDetailObj[item.prop] }}</span>
            </div>
          </div>
          <p style="font-weight:700;font-size:17px">报价信息</p>
          <el-table align="center" :header-cell-style="{
                    background: '#eef1f6',
                    color: '#606266',
                  }" size="mini" highlight-current-row :data="addObject.dataTable.tableBody" style="width: 100%; margin-top: 10px">
            <el-table-column type="index" width="50">
            </el-table-column>
            <el-table-column v-for="(item, index) in addObject.dataTable.tableHead" :key="index" align="center" :label="item.value">
              <template slot-scope="scope">
                <!-- 起运地  -->
                <div v-if="item['attrName'] == 'start'" style="
                          display: flex;
                          justify-content: space-between;
                          margin: 5px;
                        ">
                  <div style="
                            width: 80%;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            margin: 0 10px;
                            text-align: center;
                          ">
                    <el-popover trigger="hover" placement="top">
                      {{
                              scope.row[item.attrName].value ||
                              "点击右侧按钮选择"
                            }}
                      <div slot="reference" class="name-wrapper">
                        {{
                                scope.row[item.attrName].value ||
                                "点击右侧按钮选择"
                              }}
                      </div>
                    </el-popover>
                  </div>

                </div>

                <!-- 目的地  -->
                <div v-if="item['attrName'] == 'end'" style="
                          display: flex;
                          justify-content: space-between;
                          margin: 5px;
                        ">
                  <div style="
                            margin: 0 10px;
                            text-align: center;
                            width: 80%;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                          ">
                    <el-popover trigger="hover" placement="top">
                      {{
                              scope.row[item.attrName].value ||
                              "点击右侧按钮选择"
                            }}
                      <div slot="reference" class="name-wrapper">
                        {{
                                scope.row[item.attrName].value ||
                                "点击右侧按钮选择"
                              }}
                      </div>
                    </el-popover>
                  </div>

                </div>
                <span v-else-if=" item['attrName'] !='end' && item['attrName'] !='start'">
                  {{scope.row[item.attrName].value}}
                </span>

              </template>
            </el-table-column>

          </el-table>
        </template>
        <template #button>
          <el-button size="mini" type="primary" @click="clearAll()">返 回</el-button>
        </template>
      </AddDialogPlus>
    </WrapCard>
  </div>
</template>

<script>
import WrapCard from "./jack-components/wrap-card";
import ErpSearchForm from "./jack-components/erp-copy/erp-search-form";
import ErpForm from "./jack-components/erp-copy/erp-form";
import ErpTable from "./jack-components/erp-copy/erp-table";
import AddDialog from "./jack-components/erp-copy/add-dialog";
import AddDialogPlus from "./jack-components/erp-copy/add-dialog-plus";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: { ErpSearchForm, ErpTable, AddDialog, WrapCard, ErpForm, AddDialogPlus },
  data () {

    //这里存放数据
    return {
      chargeID:'',
      showObjectDetail: [
        { name: "产品名称", prop: "logisticsProductName" },
        { name: "计费等级", prop: "vipId" },
        { name: "商品分类", prop: "scaleMsg" },
        { name: "收费币种", prop: "currency" },
        // { name: "最低计费", prop: "sectionName" },
        { name: "进位方式", prop: "scale" },
        { name: "生效日期", prop: "effectiveStartTime" },
        { name: "失效日期", prop: "effectiveEndTime" },

      ],
      showDetailObj: {},
      showDetail: false,
      productCodeListCopy: [],
      statusList: [
        { label: "全部", value: 0 },
        { label: "草稿", value: 1 },
        { label: "发布", value: 2 },
        { label: "作废", value: 3 },
      ],
      rangeList: [],
      showRange: false,
      list: [],
      categoryList: [],
      polList: [],
      podList: [],
      feeTemplate: [],
      VipList: [],
      currencyList: [],
      showDialog: false,
      productCodeList: [],
      tableData: [],

      // 主表循环参数
      innerData: [
        // 需要序号就添加 type
        { name: "序号", value: "", type: "index", width: "60" },
        { name: "产品名称", value: "name" },
        { name: "商品分类", value: "goodstype" },
        { name: "收费币种", value: "currency" },
        { name: "计费等级", value: "vipcode" },
        { name: "生效日期", value: "effectiveStartTime" },

        { name: "计费系数", value: "scale" },
        { name: "失效日期", value: "effectiveEndTime" },
        { name: "状态", value: "state" }, //需要特殊处理
        //  <template slot-scope="scope">
        //     <span v-if="scope.row.state == 1">草稿</span>
        //     <span v-if="scope.row.state == 2">发布</span>
        //     <span v-if="scope.row.state == 3">作废</span>
        //   </template>
        { name: "提交人", value: "submitTime" },
        { name: "提交时间", value: "submitTime" },
        { name: "审核人", value: "reviewer" },
        { name: "审核时间", value: "reviewTime" },
        { name: "审核原因", value: "reviewReason" },
      ],
      tabelParams: {
        tabelStyle: {
          margin: "10px",
          "min-width": "980px",
        },
        operateWidth: '220px'
        , size: "mini",
        datas: {
          tableData: () => {
            return this.list;
          },
          innerData: () => {
            return this.innerData;
          },
        },
        event: {
          sizeChange: (val) => {
            return this.handleSizeChange(val);
          },
          currentChange: (val) => {
            return this.handleCurrentChange(val);
          },
        },
        tableEvent: {
          needCopy: false,
          getListById: (id, val) => {
            // console.log(id);
            return this.getListById(id);
          },
          updatestate: (id, val) => {
            // console.log(id,val);
            return this.updatestate(id, val);
          },
          copy: (id) => {
            // console.log(id,val);
            return this.copy(id);
          },
        },
      },
      tabelParamsForRange: {
        call: (param) => {
          return Object.prototype.toString.call(param) === "[object Function]";
        },
        hideOperate: true,
        tabelStyle: {
          margin: "10px",
          "min-width": "980px",
        },
        size: "mini",
        datas: {
          tableData: () => {
            return this.rangeList;
          },
          innerData: () => {
            return [
              // 需要序号就添加 type
              { name: "序号", value: "", type: "index", width: "60" },
              { name: "分区方案名称", value: "regionName" },
              { name: "所属国家", value: "country" },
              { name: "分区信息", value: "region" },
              { name: "备注", value: "remark" },
            ];
          },
        },
        event: {
          sizeChange: (val) => {
            return this.handleSizeChange(val);
          },
          currentChange: (val) => {
            return this.handleCurrentChange(val);
          },
        },
        // 这里的方法不需要了
        tableEvent: {
          rowClick: (item) => {
            // console.log(id);
            return this.rowClick(item);
          },
          getListById: (id, val) => {
            // console.log(id);
            // return this.getListById(id);
          },
          updatestate: (id, val) => {
            // console.log(id,val);
            // return this.updatestate(id, val);
          },
        },
      },

      requestParams: {
        code: "",
        name: "",
        vipcode: "",
        pageSize: 20,
        state: null, //状态，1：草稿，2：发布，3：作废
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      requestParamsForRange: {
        hidePage: true,
        pageNum: 1,
        pageSize: 10,
      },
      fromParams: {
        showSearchBtn: true,
        showAddBtn: true,
        showResetBtn: false,
        call: (param) => {
          return Object.prototype.toString.call(param) === "[object Function]";
        },
        outSideStyle: {
          width: "600px",
          display: "flex",
          "flex-wrap": "wrap",
          "align-items": "center",
          "pdding-bottom": "20px",
        },
        mainSearchList: [
          {
            type: "select",
            divWidth: "360px",
            display:'block',
            needAutoQuery: false,
            selectLabel: "name",
            selectValue: "id",
            require: true,
            spanName: "产品代码",
            spanWidth: "85px",
            modelObj: {
              objName: "addObject",
              value: "logisticsProductId",
            },
            list: () => {
              return this.productCodeList;
            },
            event: {
              focus: (val) => {//获取光标
                // 如果搜索没有数据 需要重新赋值
                if (!this.productCodeList.length) {
                  this.productCodeList = this.productCodeListCopy;
                }
                //没选而且copy有值说明搜索过，下次打开只会显示之前搜索的 需要重新赋值初始数据
                if (
                  !this.addObject.logisticsProductId &&this.productCodeListCopy.length
                ) {
                  this.productCodeList = this.productCodeListCopy;
                }
              },
              filter: (val) => {//输入的时候
                if (!this.productCodeListCopy.length) {
                  // 先拷贝一份 后续基于这里搜索
                  this.productCodeListCopy = this.productCodeList;
                }
                if (!val) {
                  //搜索框没传值就重新赋值
                  this.productCodeList = this.productCodeListCopy;
                  return;
                }
                this.productCodeList = [];
                this.productCodeListCopy.length &&
                  this.productCodeListCopy.forEach((item) => {
                    if (item.code.indexOf(val) != -1) {
                      this.productCodeList.push(item); //把匹配到的数据push
                    }
                  });
              },

              changeProduct: (i, autoQuery) => { //新增 产品报价时
                this.getFeeTemplate(i)
                this.addObject.goodstypeList = [];
                this.categoryList = [];
                let tempBody = this.addObject.dataTable.tableBody[0];
                this.addObject.dataTable.tableBody = [];
                Object.keys(tempBody).forEach((item) => {
                  tempBody[item].value = "";
                });
                this.addObject.dataTable.tableBody.push(tempBody);

                if (!i) {
                  this.addObject.logisticsProductName = "";
                  return;
                }
                let code;
                let id;
                // 拿到产品名称
                this.productCodeList.forEach((e) => {
                  if (e.id == i) {
                    this.addObject.logisticsProductName = e.name;
                    this.addObject.logisticsProductId = e.id;
                     this.addObject.chargeCoefficient = e.chargeCoefficient
                      this.addObject.chargeType = e.chargeType
                      this.addObject.minimumCbm = e.minimumCbm
                      this.addObject.minimumWeight = e.minimumWeight
                    code = e.code;
                    id = e.id
                  }
                });
                if (code) {
                  // 获取起运和目的List
                  this.getPolAndPodList(id);
                  //   get商品分类
                  this.getGoodsCategory(id);
                }
              },
              clear: (i) => {
                this.getList();
              },
            },
            margin: "0px 10px",
          },
          
          {
            type: "input",
            size: "mini",
            require: true,
            inputWidth: "250px",
            needAutoQuery: false,
            Name: "计费方式",
            disabled: true,
            placeholder: "请先选择产品代码",
            modelObj: {
              objName: "addObject",
              value: "chargeType",
            },
            event: {
              clear: (i) => {
                // this.getList(1);
              },
            },
            margin: "10px 0",
          },
          {
            type: "input",
            size: "mini",
            require: true,
            inputWidth: "250px",
            needAutoQuery: false,
            Name: "计费系数",
            placeholder: "请先选择产品代码",
            disabled: true,
            modelObj: {
              objName: "addObject",
              value: "chargeCoefficient",
            },
            event: {
              clear: (i) => {
                // this.getList(1);
              },
            },
            margin: "10px",
          },
          {
            type: "input",
            size: "mini",
            require: true,
            inputWidth: "250px",
            needAutoQuery: false,
            Name: "最低重量",
            placeholder: "请先选择产品代码",
            disabled: true,
            modelObj: {
              objName: "addObject",
              value: "minimumWeight",
            },
            event: {
              clear: (i) => {
                // this.getList(1);
              },
            },
            margin: "10px 0",
          },
          {
            type: "input",
            size: "mini",
            require: true,
            inputWidth: "250px",
            needAutoQuery: false,
            Name: "最低体积",
            placeholder: "请先选择产品代码",
            disabled: true,
            modelObj: {
              objName: "addObject",
              value: "minimumCbm",
            },
            event: {
              clear: (i) => {
                // this.getList(1);
              },
            },
            margin: "10px",
          },
          
          

          // {
          //   type: "input",
          //   size: "mini",
          //   require: true,
          //   inputWidth: "250px",
          //   needAutoQuery: false,
          //   Name: "产品名称",
          //   placeholder: "请先选择产品代码",
          //   disabled: false,
          //   modelObj: {
          //     objName: "addObject",
          //     value: "logisticsProductName",
          //   },
          //   event: {
          //     clear: (i) => {
          //       // this.getList(1);
          //     },
          //   },
          //   margin: "0 10px 0 0",
          // },

          {
            type: "select",
            inputWidth: "100%",
            divMargin: "10px 0 0 0",
            divWidth: "500px",
            multiple: true,
            needAutoQuery: false,
            selectLabel: "name",
            selectValue: "id",
            require: true,
            spanName: "商品分类",
            spanWidth: "80px",
            placeholder: '请先选择产品代码',
            modelObj: {
              objName: "addObject",
              value: "goodstypeList",
            },
            list: () => {
              return this.categoryList;
            },
            event: {
              changeProduct: (i, autoQuery) => {
                this.addObject.goodstypeList = i;
                console.log(i);
              },
              clear: (i) => {
                this.getList();
              },
            },
            margin: "0 0 0 10px",
          },
          {
            type: "select",
            divWidth: "",
            needAutoQuery: false,
            selectLabel: "vipcode",
            selectValue: "vipId",
            require: true,
            spanName: "计费等级",
            spanWidth: "85px",
            modelObj: {
              objName: "addObject",
              value: "vipId",
            },
            list: () => {
              return this.VipList;
            },
            event: {
              changeProduct: (i, autoQuery) => {
                console.log(i);
              },
              clear: (i) => {
                this.getList();
              },
            },
            margin: "0px 10px",
          },
          {
            type: "select",
            divWidth: "",
            needAutoQuery: false,
            selectLabel: "name",
            selectValue: "value",
            spanName: "收费币种",
            require: true,
            spanWidth: "85px",
            modelObj: {
              objName: "addObject",
              value: "currency",
            },
            list: () => {
              return this.currencyList;
            },
            event: {
              changeProduct: (i, autoQuery) => {
                // console.log(i);
              },
              clear: (i) => {
                this.getList();
              },
            },
            margin: "10px 10px",
          },
          {
            type: "date-picke",
            isDatetime: "datetime",
            valueFormat: "yyyy-MM-dd HH:mm",
            size: "mini",
            divWidth: "275px",
            pickerSetTime: true,
            spanWidth: "90px",
            needAutoQuery: false,
            require: true,
            clearable: true,
            name: "有效时间",
            modelObj: {
              objName: "addObject",
              value: "effectiveStartTime",
            },
            placeholder: "",

            event: {
              change: (i, autoQuery) => { },
              clear: () => {
                // console.log(123);
                this.getList();
              },
            },
            margin: "0px 10px",
          },

          {
            type: "date-picke",
            isDatetime: "datetime",
            valueFormat: "yyyy-MM-dd HH:mm",
            size: "mini",
            divWidth: "275px",
            spanWidth: "100px",
            needAutoQuery: false,
            pickerSetTime: true,
            require: true,
            clearable: true,
            name: "失效时间",
            modelObj: {
              objName: "addObject",
              value: "effectiveEndTime",
            },
            placeholder: "",
            event: {
              change: (i, autoQuery) => {
                if (!this.addObject.effectiveStartTime) {
                  this.$message.info("请先选择有效时间");
                  this.addObject.effectiveEndTime = "";
                }
                if (this.addObject.effectiveStartTime < i) {
                } else {
                  this.addObject.effectiveEndTime = "";
                  this.$message.info("失效必须大于有效时间");
                }
              },
              clear: () => {
                this.getList();
              },
            },
            margin: "0px 10px",
          },

          {
            type: "empty",
            Width: "",
            margin: "0 10px 0 0",
          },
        ],
      },
      // 模板表单数据
      fromParams2: {
        showSearchBtn: true,
        showAddBtn: true,
        showResetBtn: false,
        call: (param) => {
          return Object.prototype.toString.call(param) === "[object Function]";
        },
        outSideStyle: {
          width: "300px",
          display: "flex",
          "flex-wrap": "wrap",
          "align-items": "center",
          "pdding-bottom": "20px",
        },
        mainSearchList: [
          {
            type: "select",
            clearable: true,
            divWidth: "",
            needAutoQuery: false,
            selectLabel: "sectionName",
            selectValue: "id",
            require: true,
            spanName: "模板名称",
            spanWidth: "80px",
            modelObj: {
              objName: "addObject",
              value: "chargeSectionHeaderId",
            },
            list: () => {
              return this.feeTemplate;
            },
            event: {
              that: this,
              changeProduct: (i, autoQuery) => {
                console.log(i); console.log(this);
                console.log(this.that);
                this.feeTemplate.forEach((e) => {
                  console.log(e);

                  //拿到单个计费对象
                  if (e.id == i) {
                    this.addObject.templateData = e;
                    // 进位
                    this.addObject.scale = e.scale;
                    this.addObject.scaleMsg = e.scaleMsg;
                    this.addObject.remarks = e.remark;
                  }
                });
                // 复制计费单位

                this.addObject.chargeType = this.addObject.templateData.chargeType;

                this.addObject.dataTable.tableBody = [];
                this.addObject.dataTable.tableHead = [
                  {
                    attrName: "start",
                    value: "起运地分区",
                  },
                  {
                    attrName: "end",
                    value: "目的地分区",
                  },
                ];
                let tempObj = {
                  start: {
                    id: 0,
                    value: "",
                  },
                  end: {
                    id: 0,
                    value: "",
                  },
                };

                // 拼接表头信息
                for (
                  let index = 0;
                  index < this.addObject.templateData.detailList.length;
                  index++
                ) {
                  this.addObject.dataTable.tableHead.push({
                    attrName: `${this.addObject.templateData.detailList[index].id}`,
                    value: `${this.addObject.templateData.detailList[index].sectionEndNum}${this.addObject.templateData.chargeType} —  ${this.addObject.templateData.detailList[index].sectionEndNum} ${this.addObject.templateData.chargeType}`,
                  });
                  // 拼接range对象
                  tempObj[
                    `${this.addObject.templateData.detailList[index].id}`
                  ] = {
                    id: 0,
                    value: "",
                    startNum: this.addObject.templateData.detailList[index]
                      .sectionStartNum,
                    endNum: this.addObject.templateData.detailList[index]
                      .sectionEndNum,
                  };
                }
                this.addObject.dataTable.tableBody.push(tempObj);

                let tempHead = this._.cloneDeep(
                  this.addObject.dataTable.tableHead
                );
                this.addObject.dataTable.tableHead = [];
                // this.addObject.dataTable.tableHead = tempHead
                // this.addObject.dataTable.tableHead.splice();
                setTimeout(() => {
                  // this.addObject.dataTable.tableBody.push({})
                  this.addObject.dataTable.tableHead = tempHead;
                  //  this.addObject.dataTable.tableHead.splice();
                  //  this.$set(this.addObject.dataTable,'tableHead', this.addObject.dataTable.tableHead)
                }, 0);
              },
              clear: (i) => {
                // this.getList();
              },
            },
            divMargin: "0px 0  10px 0",
          },

          {
            type: "input",
            size: "mini",
            inputWidth: "250px",
            needAutoQuery: false,
            Name: "进位方式",
            placeholder: "请选择模板",
            disabled: true,
            modelObj: {
              objName: "addObject",
              value: "scaleMsg",
            },
            event: {
              clear: (i) => {
                // this.getList(1);
              },
            },
            margin: "0 0px 10px 0",
          },

          {
            type: "input",
            size: "mini",
            inputWidth: "250px",
            needAutoQuery: false,
            Name: "描述",
            placeholder: "请选择模板",
            disabled: true,
            modelObj: {
              objName: "addObject",
              value: "remarks",
            },
            event: {
              clear: (i) => {
                // this.getList(1);
              },
            },
            margin: "0 10px 0 0",
          },
          // {
          //   type: "input",
          //   size: "mini",
          //   inputWidth: "250px",
          //   needAutoQuery: false,
          //   Name: "计费单位",
          //   placeholder: "请选择模板",
          //   disabled: true,
          //   modelObj: {
          //     objName: "addObject",
          //     value: "chargeType",
          //   },
          //   event: {
          //     clear: (i) => {
          //       // this.getList(1);
          //     },
          //   },
          //   margin: "10px 0 0 0",
          // },
        ],
      },
      searchFromParams: {
        showSearchBtn: true,
        showAddBtn: true,
        showResetBtn: false,
        call: (param) => {
          return Object.prototype.toString.call(param) === "[object Function]";
        },
        outSideStyle: {
          width: "60%",
          display: "flex",
          "flex-wrap": "wrap",
          "align-items": "center",
          "pdding-bottom": "20px",
        },
        mainSearchList: [
          {
            type: "select",
            divWidth: "",
            needAutoQuery: false,
            selectLabel: "code",
            selectValue: "code",
            spanName: "产品代码",
            spanWidth: "80px",
            modelObj: {
              objName: "requestParams",
              value: "code",
            },
            list: () => {
              return this.productCodeList;
            },
            event: {
              focus: (val) => {
                // 如果搜索没有数据 需要重新赋值
                if (!this.productCodeList.length) {
                  this.productCodeList = this.productCodeListCopy;
                }
                //没选而且copy有值说明搜索过，下次打开只会显示之前搜索的 需要重新赋值初始数据
                if (!this.requestParams.code &&this.productCodeListCopy.length) {
                  this.productCodeList = this.productCodeListCopy;
                }
              },
              filter: (val) => {
                if (!this.productCodeListCopy.length) {
                  // 先拷贝一份 后续基于这里搜索
                  this.productCodeListCopy = this.productCodeList;
                }
                if (!val) {
                  //搜索框没传值就重新赋值
                  this.productCodeList = this.productCodeListCopy;
                  return;
                }
                this.productCodeList = [];
                this.productCodeListCopy.length &&
                  this.productCodeListCopy.forEach((item) => {
                    if (item.code.indexOf(val) != -1) {
                      this.productCodeList.push(item); //把匹配到的数据push
                    }
                  });
              },
              changeProduct: (i, autoQuery) => { },
              clear: (i) => {
                this.getList(1);
              },
            },
            margin: "10px 10px",
          },
          {
            type: "input",
            size: "mini",
            inputWidth: "250px",
            needAutoQuery: false,
            Name: "产品名称",
            placeholder: "",
            modelObj: {
              objName: "requestParams",
              value: "name",
            },
            event: {
              clear: (i) => {
                this.getList(1);
              },
            },
            margin: "0 10px 0 0",
          },
          {
            type: "select",
            divWidth: "",
            needAutoQuery: false,
            selectLabel: "vipcode",
            selectValue: "vipId",
            spanName: "计费等级",
            spanWidth: "80px",
            modelObj: {
              objName: "requestParams",
              value: "vipcode",
            },
            list: () => {
              return this.VipList;
            },
            event: {
              changeProduct: (i, autoQuery) => { },
              clear: (i) => {
                this.getList(1);
              },
            },
            margin: "10px 10px",
          },
          {
            type: "select",
            divWidth: "",
            needAutoQuery: false,
            selectLabel: "",
            selectValue: "",
            spanName: "状态",
            spanWidth: "80px",
            modelObj: {
              objName: "requestParams",
              value: "state",
            },
            list: () => {
              return this.statusList;
            },
            event: {
              changeProduct: (i, autoQuery) => { },
              clear: (i) => {
                this.getList(1);
              },
            },
            margin: "10px 10px",
          },
        ],
      },
      testData: {
        tableHead: [
          {
            attrName: "start",
            value: "起运地分区",
          },
          {
            attrName: "end",
            value: "目的地分区",
          },
          {
            attrName: "range1",
            value: "0-500KG",
          },
        ],
        tableBody: [
          {
            start: {
              id: 2222,
              value: "华南",
            },
            end: {
              id: 2237,
              value: "迪拜",
            },
            range1: {
              id: 0,
              value: "",
              endV: 0,
              startV: 10,
            },
          },
        ],
      },
      addObject: {
        isPod: null,
        currentSelectedIndex: 0,
        logisticsProductName: "",
        type: "I",
        chargeType: "",
        scale: "",
        remarks: "",
        state: "1",
        logisticsProductId: "",
        // ---------------------
        chargeCoefficient:'',
        chargeType:'',
        minimumCbm: '',
        minimumWeight: '',
        // --------------------
        vipId: "",
        currency: "",
        effectiveStartTime: "",
        effectiveEndTime: "",
        chargeType: "",
        chargeSectionHeaderId: "",
        goodstypeList: [],
        templateId: "",
        templateData: {},
        dataTable: {
          tableHead: [
            {
              attrName: "start",
              value: "起运地分区",
            },
            {
              attrName: "end",
              value: "目的地分区",
            },
          ],
          tableBody: [
            {
              start: {
                id: 0,
                value: "",
              },
              end: {
                id: 0,
                value: "",
              },
            },
          ],
        },
      },
    };
  },
  //监听属性 类似于data概念
  computed: {

  },
  //监控data中的数据变化
  watch: {

  },
  //方法集合
  methods: {

    // 提交
    submitPrice (id) {
      console.log(id);

      this.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {

          this.axios.get(`/carrier/productPrice/submitCarrierProductPrice/${id}`)
            .then((res) => {
              if (res.data.code == 200) {
                this.$message.success('提交成功');
                this.getList(1)
              } else {
                this.$message.info(res.data.message);
              }
            }).catch((res) => {
              console.log(res);
            });

        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });

    },
    valieDataForInput (v, obj, name) {
      v == -0 && (obj[name] = ""); // -0的情况
      //1输入的值//2v-model//3绑定的属性名
      !(v >= 0) && (obj[name] = ""); //小于0就
    },
    copy (id) {
      console.log(id);
      let tempHandler = this.addObject.clearHandle;
      this.axios
        .get(
          `erp/service?src=fbxOnline&action=getFbaProductPriceSingleInfo&id=${id}`
        )
        .then((res) => {
          if (res.data.isSuccess) {
            this.addObject = res.data.data;
            this.addObject.state = 1;
            this.addObject.clearHandle = tempHandler;
            this.addObject.id = "";
            this.polList = res.data.data.polList || [];
            this.podList = res.data.data.podList || [];
            this.categoryList = res.data.data.categoryList;
            res.data.data.templateData.forEach((item) => {
              if (item.id == res.data.data.chargeSectionHeaderId) {
                res.data.data.templateData = item;
                this.addObject.scale = item.scale;
                this.addObject.remarks = item.remark;
              }
            });
            if (this.productCodeListCopy.length) {
              //有则说明打开搜索过
              // 需要重新赋值，不然搜索结果会留下
              this.productCodeList = this.productCodeListCopy;
            }
            this.showDialog = true;
            // this.submit();
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    deleteItem (index) {
      if (this.addObject.dataTable.tableBody.length == 1) {
        return this.$message.info("最少保留一项！");
      }
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.addObject.dataTable.tableBody.splice(index, 1);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    warn () {
      if (this.addObject.state == 2) {
        this.$message.info("处于发布状态不可编辑");
      } else if (this.addObject.state == 3) {
        this.$message("处作废状态不可编辑");
      }
    },
    rowClick (item) {
      let index = this.addObject.currentSelectedIndex;
      let info = ` ${item.regionName} (${item.region})`;
      if (this.addObject.isPod == "pod") {
        this.addObject.dataTable.tableBody[index].end.value = info;
        this.addObject.dataTable.tableBody[index].end.id = item.id;
      } else if (this.addObject.isPod == "pol") {
        this.addObject.dataTable.tableBody[index].start.value = info;
        this.addObject.dataTable.tableBody[index].start.id = item.id;
      }
      this.showRange = false;
      console.log(item);
    },
    selectDes (type, index) {
      // 没选产品代码或模板就返回
      if (!this.categoryList.length) {
        return this.$message("请先选择产品代码");
      }

      if (!this.addObject.chargeSectionHeaderId) {
        return this.$message("请先选择计费模板");
      }
      // console.log(index);
      this.addObject.currentSelectedIndex = index;
      this.addObject.isPod = type;
      type == "pod"
        ? (this.rangeList = this.podList)
        : (this.rangeList = this.polList);
      this.showRange = true;
    },
    add () {
      // 没选产品代码或模板就返回
      if (!this.categoryList.length) {
        return this.$message("请先选择产品代码");
      }
      if (!this.addObject.chargeSectionHeaderId) {
        return this.$message("请先选择计费模板");
      }
      let len = this.addObject.dataTable.tableBody.length;
      let tableBody = this.addObject.dataTable.tableBody;
      let record = "";
      for (let i = 0; i < len; i++) {
        if (record) {
          break;
        }
        let objKeys = Object.keys(tableBody[i]);
        console.log(objKeys);
        for (let innerIndex = 0; innerIndex < objKeys.length; innerIndex++) {
          if (record) {
            break;
          }
          if (!tableBody[i][objKeys[innerIndex]].value) {
            record = `第${i + 1}行-第${innerIndex + 1}项不能为空`;
          }
        }
      }
      if (record) {
        this.$message(record);
        return;
      }

      let temp = JSON.parse(
        JSON.stringify(this.addObject.dataTable.tableBody[0])
      );
      Object.keys(temp).forEach((item) => {
        temp[item].value = "";
      });
      this.addObject.dataTable.tableBody.push(temp);
    },
    test () { },
    // 更新状态
    updatestate (id, state) {
      let msg = "";
      switch (state) {
        case 2:
          msg = "发布吗？发布成功后启用该报价！";
          break;
        case 3:
          msg = "作废吗？作废成功后该报价失效！";
          break;

        default:
          break;
      }

      this.$confirm("确认" + msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              `/erp/service?src=fbxOnline&action=updateFbaProductPriceStatus&id=${id}&status=${state}`
            )
            .then((res) => {
              // console.log(res);
              if (res.data.isSuccess) {
                this.$message.success(res.data.error || "更新成功");
                this.clearAll();
                this.getList();
              } else {
                this.$message.info(res.data.error || "更新失败");
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    showDetailHandler (row) {
      this.getListById(row, true)
    },
    getListById (id, isCheckDetail) {

      console.log(id);
      let tempHandler = this.addObject.clearHandle;
      this.axios
        .get(
          `/carrier/productPrice/getCarrierProductPriceInfo/${id.row.id}`
        )
        .then((res) => {
          if (res.data.code == 200) {

            console.log(res.data.data);

            this.addObject = res.data.data;

            this.categoryList = res.data.data.categoryList;
            let tempTempaltelist = []
            res.data.data.templateData.forEach((item) => {
              //  console.log(item); 获取detailList循环出来
              if (item.id == res.data.data.chargeSectionHeaderId) {
                tempTempaltelist = item;
                this.addObject.scale = item.scale;
                this.addObject.remarks = item.remark;
              }
            });
            res.data.data.templateData = tempTempaltelist

            this.addObject.chargeSectionHeaderId =
              res.data.data.chargeSectionHeaderId;
            if (!isCheckDetail) {
              this.showDialog = true;
            }
            if (this.productCodeListCopy.length) {
              //有则说明打开搜索过
              // 需要重新赋值，不然搜索结果会留下
              this.productCodeList = this.productCodeListCopy;
            }
            this.polList = res.data.data.polList || [];
            this.podList = res.data.data.podList || [];
            this.addObject.clearHandle = tempHandler;


            // 如果是查看
            if (isCheckDetail) {
              this.showDetailObj = res.data.data
              this.showDetail = true


              // 后端说需要前端获取这里的数据
              // 获取 vip 名称
              this.VipList.find(item => {
                if (item.vipId == this.addObject.vipId) {
                  this.showDetailObj.vipId = item.vipcode
                }
              })
              // 获取 进位 名称
              this.feeTemplate.find(item => {

                // console.log(res.data.data);
                if (item.scale == this.addObject.scale) {

                  this.showDetailObj.scale = item.scaleMsg
                }
              })
              // 获取 商品分类名称
              let name = ''

              this.addObject.goodstypeList.forEach(item => {
                this.addObject.categoryList.forEach(item2 => {
                  if (item2.id == item) {
                    name += ` ${item2.name}`
                  }
                })
              })
              this.addObject.scaleMsg = name
            }
          } else {
            this.$message.info(res.data.message);
          }
          this.getList();
        })
        .catch((res) => {
          console.log(res);
        });
    },
    getList (type) {
      if (type) {
        this.requestParams.pageNum = 1;
      }
      this.axios
        .post(
          `/carrier/productPrice/getCarrierProductPriceList`,
          this.requestParams
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.list = res.data.data.list;
            // console.log(res.data.data.total);
            setTimeout(() => {
              this.requestParams.total = +res.data.data.total;
            }, 200);
            // console.log(this.requestParams);
          } else {
            this.$message.info(res.data.error);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    openAddDialog () {
      this.showDialog = true;
      if (this.productCodeListCopy.length) {
        //有则说明打开搜索过
        // 需要重新赋值，不然搜索结果会留下
        this.productCodeList = this.productCodeListCopy;
      }
      this.polList = []; //情况目的和起运List  不然会有脏数据
      this.podList = [];
      this.getFeeTemplate(); //重新获取模板信息 不然 看详情后会留下数据
    },
    // 表单校验
    valiDataFrom () {
      let stop = false
      let isEmpty = (value, msg) => {
        if (value === undefined) {//如果有一个没通就提前结束
          return true
        }
        if (stop) {//如果有一个没通就提前结束
          return true
        }
        if (!value) {
          this.$message.info(`${msg} 不能为空`)
          stop = true
        }
        return !value
      }
      let booleanList = []
      // 产品代码
      booleanList.push(isEmpty(this.addObject.logisticsProductId, '产品代码'))
      // 商品分类
      booleanList.push(isEmpty(this.addObject.goodstypeList.length, '商品分类'))
      // 计费等级
      booleanList.push(isEmpty((this.addObject.vipId), '计费等级'))
      // 收费币种
      booleanList.push(isEmpty((this.addObject.currency), '收费币种'))
      // 有效时间
      booleanList.push(isEmpty((this.addObject.effectiveStartTime), '有效时间'))
      // 失效时间
      booleanList.push(isEmpty((this.addObject.effectiveEndTime), '失效时间'))
      // 计费模板 
      booleanList.push(isEmpty((this.addObject.templateData.id ? this.addObject.templateData.id : false), '计费模板'))
      // console.log(booleanList);
      for (let i = 0; i < booleanList.length; i++) {
        if (booleanList[i]) {
          return true
        }
      }

      // 开始校验动态表格
      let getName = (arrt) => {
        let name = ''

        if (arrt == 'start') {
          name = "起运地分区"
        } else if (arrt == 'end') {
          name = "目的地分区"
        } else {
          name = "价格区间"
        }
        return name
      }
      let len = this.addObject.dataTable.tableBody.length;
      let tableBody = this.addObject.dataTable.tableBody;
      let record = "";
      for (let i = 0; i < len; i++) {
        if (record) {
          break;
        }
        let objKeys = Object.keys(tableBody[i]);
        console.log(objKeys);
        for (let innerIndex = 0; innerIndex < objKeys.length; innerIndex++) {
          if (record) {
            break;
          }
          if (!tableBody[i][objKeys[innerIndex]].value) {
            record = `第${i + 1}行-${getName(objKeys[innerIndex])}不能为空`;
          }
        }
      }
      if (record) {
        this.$message(record);
        return true;
      }
      // 通过
      return false
    },
    submit () {
      if (this.valiDataFrom()) {
        return
      }
      let tempTemplateData
      // 后端不需要tempTemplateData  所以要么删除要么改成数组传过去
      // 问题2 如果修改或者新增后台返回-1 那么是需要把tempTemplateData重新赋值回去 不然会报错
      if (this.addObject.templateData) {
        this.addObject.chargeType = this.addObject.templateData.chargeType;
        // this.addObject.chargeSectionHeaderId = this.addObject.templateData.id;
        tempTemplateData = this._.cloneDeep(this.addObject.templateData)
        this.addObject.templateData = []
      }
      if (this.addObject.id) {
        this.addObject.type = "U";
      } else {
        this.addObject.type = "I";
      }
      // 明天做校验
      this.axios
        .post(
          `/carrier/productPrice/insertOrUpdateCarrierProductPrice`,
          this.addObject
        )
        .then((res) => {

          if (res.data.code == 200) {
            this.$message.success(this.addObject.id ? "修改成功" : "新增成功");
            this.showDialog = false;
            this.clearAll();
            this.getList();
          } else {
            this.$message.info(res.data.message);
            this.addObject.templateData = tempTemplateData


          }
        })
        .catch((res) => {
          console.log(res);
        });


    },
    clearAll () {
      this.categoryList = [];
      this.addObject.clearHandle();
      this.showDialog = false;
      this.showDetail = false;
    },
    handleSizeChange (val) {
      this.requestParams.pageSize = val;
      this.getList();
    },
    handleCurrentChange (val) {
      this.requestParams.pageNum = val;
      this.getList();
    },
    // 获取基础信息
    // 获取 起运地、目的地
    getPolAndPodList (code) {
      this.axios
        .get(
          `/carrier/baseData/getCarrierRegionByProduct/${code}`
        )
        .then((res) => {
          console.log(`------------获取 起运地、目的地-------------`);
          console.log(res.data.data);
          if (res.data.code == 200) {
            this.polList =
              (res.data.data &&
                res.data.data.pol.length &&
                res.data.data.pol) ||
              this.$message.info(`起运地 没有相关数据`);
            this.podList =
              (res.data.data &&
                res.data.data.pod.length &&
                res.data.data.pod) ||
              this.$message.info(`目的地 没有相关数据`);
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 获取 产品代码
    getProductCodeList () {
      this.getBaseList({
        methods: 'post'
      },"/carrier/baseData/getCarrierProductList","产品代码","productCodeList");
    },
    getBaseList (methods, url, name, listName) {
      this.axios[methods.methods](
        `${url}`,
        methods.params ? methods.params : ""
      )
        .then((res) => {
          console.log(`------------获取 ${name}-------------`);
          console.log(res.data.datas);
          if (res.data.code == 200) {
            this[listName] =
              (res.data &&
                res.data.datas.length &&
                res.data.datas) ||
              this.$message.info(`${name} 没有相关数据`);
            // 总条数赋值
            this.requestParams.total = res.data.data && res.data.data.total || 0;
            if (methods.cb) {
              methods.cb()
            }

          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },

    // 获取VipList
    getVipList () {
      this.getBaseList({ methods: 'post' },
        "/filedata/findFbaVipInfoAll",
        "VipList",
        "VipList"
      );
    },
    // 获取币种
    getAllCurreny () {
      this.getBaseList({
        methods: 'get', cb: () => {
          this.currencyList = this.currencyList.map(item => {
            return { name: item, value: item }
          })
        }
      },
        "/filedata/findCurrencyAll",
        "获取币种",
        "currencyList"
      );
    },
    // 获取 商品分类
    getGoodsCategory (id) {
      this.getBaseList(
        { methods: 'get' },
        `/carrier/baseData/getGoodstypeListByProduct/${id}`,
        "商品分类",
        "categoryList"
      );
    },
    // 获取 计费模板
    getFeeTemplate (id) {
      if(!id) return
      this.getBaseList(
        { methods: 'post'},
        `/carrier/baseData/getCarrierChargeSectionList/${id}`,
        "计费模板",
        "feeTemplate"
      );
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created () {
    (() => {
      let innerData = this._.cloneDeep(this.addObject);
      let clearHandle = () => {
        this.addObject = this._.cloneDeep(innerData);
        this.addObject.clearHandle = clearHandle;
      };
      this.addObject.clearHandle = clearHandle;
    })();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    // // 产品代码
    this.getProductCodeList();
    // // 获取VipList
    this.getVipList();
    // // 获取币种
    this.getAllCurreny();

    // // 获取 List
    this.getList();
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/QuotationManagement/ProductQuotation.vue